import styled from 'styled-components';
import { Checkbox } from 'antd';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Title = styled.h2`
  font-size: 34px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.02em;
  text-align: left;
  color: var(--primary-dark-two);
  margin: 0px 0;
`;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Head = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Div = styled.div`
  input[name='ar-title'] {
    direction: rtl;
    text-align: right;
  }

  input[name='ar-option'] {
    direction: rtl;
    text-align: right;
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
`;

export const SwitchTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  margin: 0;
`;

export const AddButton = styled.button`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  display: flex;
  align-items: center;
  gap: 5px;
  border: none;
  background: none;
  color: var(--primary-green);
`;

export const Icon = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-green);
  line-height: 0;
  border-radius: 40px;
  margin: auto;
  cursor: pointer;
  border: none;
  /* padding: 10px; */
`;

export const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const Text = styled.p`
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  flex-grow: 1;
  color: #2d3748;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const EditButton = styled.button`
  width: 40px;
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef1f6;
  line-height: 0;
  border-radius: 40px;
  cursor: pointer;
  border: none;
`;

export const DeleteButton = styled.button`
  min-width: 40px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fdf0ef;
  line-height: 0;
  border-radius: 40px;
  border: none;
  cursor: pointer;
`;

export const List = styled.ul`
  list-style: none;
`;

export const ListItem = styled.li`
  gap: 7px;
  background: #f7f8fc;
  padding: 15px 10px;
  border-radius: 12px;
  margin: 10px 0;
`;

export const Type = styled.span`
  font-family: Poppins;
  font-size: 9px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: center;
  height: 14px;
  background: rgba(233, 249, 247, 1);
  border-radius: 8px;
  color: var(--primary-green);
`;

export const TextChoice = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: #2d3748;
  padding: 0;
`;

export const CustomCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    border-color: #e8c9bf !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: #e8c9bf !important;
    background-color: #e8c9bf !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #d18363 !important;
  }

  .ant-checkbox-title {
    font-weight: 600;
  }
`;

export const Button = styled.button`
  height: 50px;
  background: var(--primary-green);
  border-radius: 10px;
  padding: 0 30px;
  border: none;
  font-style: normal;
  font-weight: 500;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  color: var(--white);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0em;

  span {
    font-weight: 700;
  }

  &:focus {
    outline: double 3px var(--primary-green) !important;
  }

  &:disabled {
    background: #b6b6b6;
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const OptionsTitle = styled.h3`
  font-weight: 700;
  margin: 0;
  font-size: 1rem;
  margin-bottom: 0.7rem;
`;

export const AddOption = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: #f6e6e0;
  color: var(--primary-green);
`;
